import config from "../../config.js";
import axios from "axios";

const DEFAULT_ALERT_PAGE_LIMIT = 100;

const ALERT_LIST_URLS = {
  all: `${config.baseURL}/alert/organization`,
  user: `${config.baseURL}/alert/organization/user`,
  vehicle: `${config.baseURL}/alert/organization/vehicle`,
  expiry: `${config.baseURL}/alert/organization/expiry`,
};

const parseHeaderNumber = (value, fallbackValue = null) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
};

export async function fetchAlertsPage(
  tabKey,
  cursor = null,
  limit = DEFAULT_ALERT_PAGE_LIMIT,
  dateRange = null,
) {
  const url = ALERT_LIST_URLS[tabKey];
  if (!url) {
    return { alerts: [], hasMore: false, nextCursor: null, total: null };
  }

  const response = await axios.get(url, {
    params: {
      limit: Math.min(limit, DEFAULT_ALERT_PAGE_LIMIT),
      ...(cursor != null ? { cursor } : {}),
      ...(dateRange?.startDate ? { startDate: dateRange.startDate } : {}),
      ...(dateRange?.endDate ? { endDate: dateRange.endDate } : {}),
    },
    withCredentials: true,
  });

  const data = response.data;
  const alerts = Array.isArray(data)
    ? data
    : Array.isArray(data?.alerts)
      ? data.alerts
      : [];
  const body = data && !Array.isArray(data) ? data : null;
  const hasMore =
    response.headers["x-alert-has-more"] === "true" || body?.hasMore === true;
  const nextCursor = parseHeaderNumber(
    response.headers["x-alert-next-cursor"],
    body?.nextCursor ?? null,
  );
  const total = parseHeaderNumber(
    response.headers["x-alert-total"],
    body?.total ?? null,
  );

  return { alerts, hasMore, nextCursor, total };
}

export async function getAlertCounts() {
  const response = await axios.get(`${config.baseURL}/alert/counts`, {
    withCredentials: true,
  });
  return response.data;
}

export async function getUserAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/user`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

export async function getVehicleAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/vehicle`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

export async function getExpiryAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/expiry`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}
// Function to delete an alert
export async function deleteAlertById(alertId) {
  const response = await axios.delete(`${config.baseURL}/alert/delete`, {
    data: { id: alertId },
    withCredentials: true,
  });
  return response.data;
}

//function to update the alert

export async function updateAlert(alertData) {
  try {
    const updatedAlert = await axios.put(`${config.baseURL}/alert`, alertData, {
      withCredentials: true,
    });

    return updatedAlert.data;
  } catch (error) {
    console.error("Failed to update alert:", error);
    throw error;
  }
}

// Function to toggle star status
export async function toggleAlertStar(alertData) {
  try {
    console.log("Making API call to toggle star with payload:", {
      alertId: alertData.id,
      isStarred: alertData.isStarred,
    });
    const response = await axios.patch(
      `${config.baseURL}/alert/starred`,
      {
        alertId: alertData.id,
        isStarred: alertData.isStarred,
      },
      { withCredentials: true }
    );
    console.log("API response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Failed to toggle alert star:",
      error.response?.data || error.message
    );
    throw error;
  }
}

// Function to get starred alerts
export async function getStarredAlerts(orgId) {
  try {
    const response = await axios.get(`${config.baseURL}/alert/starred`, {
      params: { organizationId: orgId },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to get starred alerts:", error);
    throw error;
  }
}
